/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import { NgModule } from '@angular/core';

import { config } from './unauthorized-page.view.config';

// You can modify or replace module config here

@NgModule(config)
export class UnauthorizedPageViewModule {}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/modules/application/unauthorized-page/unauthorized-page.view.module.ts